import { render, staticRenderFns } from "./Soarchieve.vue?vue&type=template&id=540b56fe&scoped=true&"
import script from "./Soarchieve.vue?vue&type=script&lang=js&"
export * from "./Soarchieve.vue?vue&type=script&lang=js&"
import style0 from "./Soarchieve.vue?vue&type=style&index=0&id=540b56fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540b56fe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
